import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { AccountsList } from 'apps/auth/components/common/AccountsList/AccountsList';
import { LinkedLine } from 'apps/auth/components/common/Card/LinkedLine';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { IconWrapper, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { PaysendLogo } from 'apps/auth/components/common/PaysendLogo/PaysendLogo';
import { Text } from 'apps/auth/components/common/Text/Text';
import { CHANGE_LINKED_ACC_POPUP } from 'apps/auth/constants/ComponentNames';
import { copyTextToClipboard } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import media from 'apps/auth/theme/media';

import CardInfo from './CardInfo';
import { CardContainer } from './styles';

const Wrapper = styled.div`
    margin-top: 20px;

    ${media.tablet720} {
        margin-top: 0;
    }
`;

const defaultCard = {
    number: '',
    cardPocket: {
        currency: {
            code: '',
        },
    },
};

const BigCardForCardDetail = (props) => {
    const { card = defaultCard, accounts } = useExtra();
    const { frozenByUserInfoError, frozenBySystemInfoError, activeWithoutPinError, expiredInfoError, expiredSoonError, copied, CardNumberCopyMessage } =
        usePageMessages();

    useEffect(() => {
        if (props.showMode && card.number) {
            const result = copyTextToClipboard(card.number);
            if (result) {
                props.toggleSnackBar(true, `${CardNumberCopyMessage} ${copied}`);
            }
        }
    }, [props.showMode, card.number, CardNumberCopyMessage, copied]);

    const getErrorText = () => {
        if (card.frozen && card.frozenByUser) {
            return <DangerouslyHtml type="span" dangerouslyHtml={frozenByUserInfoError} />;
        } else if (card.frozen && card.frozenBySystem) {
            return <DangerouslyHtml type="span" dangerouslyHtml={frozenBySystemInfoError} />;
        } else if (card.activeWithoutPin) {
            return <DangerouslyHtml type="span" dangerouslyHtml={activeWithoutPinError} />;
        } else if (card.expiredSoon) {
            return <DangerouslyHtml type="span" dangerouslyHtml={expiredSoonError} />;
        } else if (card.expired) {
            return <DangerouslyHtml type="span" dangerouslyHtml={expiredInfoError} />;
        }
    };

    const getLogoColor = (currCard) => {
        if (card.plastic) {
            return 'white';
        } else {
            return currCard.blocked ? 'lightGray' : 'darkGray';
        }
    };

    return (
        <>
            <Wrapper>
                <Row indent="adaptive-24-32">
                    <CardContainer isPlastic={card.plastic} isBlocked={card.blocked}>
                        <PaysendLogo color={getLogoColor(card)} />
                        <CardInfo showMode={props.showMode} card={card} />
                    </CardContainer>
                    <LinkedLine />
                    <AccountsList
                        isLinked
                        isHoverable
                        onAccountClick={(e) => {
                            e.preventDefault();
                            if (!card.blocked && accounts && accounts.length > 1) {
                                props.setPopups(CHANGE_LINKED_ACC_POPUP);
                                props.popupRef?.current?.open();
                            }
                        }}
                    >
                        <PanelRow alignStart>
                            <IconWrapper>
                                <DiskBadge
                                    src={props.getCurrencyIcon(card.cardPocket.currency.code.toLowerCase())}
                                    alt={card.cardPocket.currency.code.toLowerCase()}
                                    onError={props.onError}
                                />
                            </IconWrapper>
                            <Text>
                                <Text color={card.blocked ? 'lightGray' : 'primary'}>
                                    {card.formattedAmount}{' '}
                                    <Text color={card.blocked ? 'lightGray' : 'primary'} smallCaps>
                                        {card.cardPocket.currency.code.toLowerCase()}
                                    </Text>
                                </Text>
                            </Text>
                        </PanelRow>
                    </AccountsList>
                </Row>
                <Text color="error">{getErrorText()}</Text>
            </Wrapper>
        </>
    );
};

export default connect(null, { toggleSnackBar })(BigCardForCardDetail);
